<div *ngIf="nodeValue" class="bg-bluegray-50 h-full">
   <div
      class="bg-white flex flex-column justify-content-between align-items-center gap-3 w-full px-3 border-bottom-1 border-200"
   >
      <span class="cursor-pointer w-full justify-content-end flex pt-4 mr-2" (click)="this.closeSidebar.emit()">
         <i class="text-bluegray-800 pi pi-times"></i>
      </span>

      <div class="flex justify-content-start align-items-center gap-3 pb-3">
         <div class="bg-blue-50 p-3 border-1 border-blue-100 border-round-lg">
            <i class="pi pi-calendar text-blue-700 text-lg"></i>
         </div>
         <div class="text-2xl text-700 font-semibold flex flex-column gap-1">
            {{ 'DATA.MODULES.INSPECTORS.OFFER_PAYMENT_AGREEMENT.TITLE' | translate }}
            <div class="text-sm font-normal text-600">
               {{ 'DATA.MODULES.INSPECTORS.OFFER_PAYMENT_AGREEMENT.DESCRIPTION' | translate }}
            </div>
         </div>
      </div>

      <div class="flex justify-content-center mb-4">
         <p-selectButton
            [options]="visibleTabs()"
            [ngModel]="activeTab()"
            (ngModelChange)="activeTab.set($event)"
            optionLabel="label"
            optionValue="value"
         ></p-selectButton>
      </div>
   </div>

   <!-- Preview tab -->
   <div *ngIf="activeTab() === 'preview'" class="p-3 pb-4">
      <div
         class="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl border border-border p-2 flex flex-column gap-3"
      >
         <label class="font-semibold text-800 mb-1">{{
            'DATA.MODULES.INSPECTORS.OFFER_PAYMENT_AGREEMENT.PREVIEW.TITLE' | translate
         }}</label>

         <div class="flex flex-column gap-4">
            <div
               class="surface-card p-4 border-1 border-round-xl border-blue-100 flex flex-row gap-4 align-items-center"
            >
               <div class="bg-cyan-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                  <i class="pi pi-list text-cyan-700 text-lg"></i>
               </div>

               <div class="flex flex-column gap-1">
                  <span class="font-medium text-500">{{
                     'DATA.MODULES.INSPECTORS.OFFER_PAYMENT_AGREEMENT.PREVIEW.INSTALLMENTS_LABEL' | translate
                  }}</span>
                  <span class="text-2xl font-semibold text-blue-800">
                     {{ previewInstalmentsText }}
                  </span>
               </div>
            </div>

            <div
               class="surface-card p-4 border-1 border-round-xl border-blue-100 flex flex-row gap-4 align-items-center mt-3"
            >
               <div class="bg-teal-50 border-round-xl flex align-items-center justify-content-center w-3rem h-3rem">
                  <i class="pi pi-clock text-teal-700 text-lg"></i>
               </div>

               <div class="flex flex-column gap-1">
                  <span class="font-medium text-500">{{
                     'DATA.MODULES.INSPECTORS.OFFER_PAYMENT_AGREEMENT.PREVIEW.EXPIRATION_LABEL' | translate
                  }}</span>
                  <span class="text-blue-800 font-semibold text-2xl">
                     {{ 'DATA.MODULES.INSPECTORS.OFFER_PAYMENT_AGREEMENT.PREVIEW.EXPIRES_IN' | translate }}
                     {{ expirationDays() ?? 0 }}
                     {{
                        (expirationDays() ?? 0) === 1
                           ? ('DATA.COMMON.TIME.DAY' | translate)
                           : ('DATA.COMMON.TIME.DAYS' | translate)
                     }}
                  </span>
               </div>
            </div>
         </div>

         <div *ngIf="errors().length" class="pt-2">
            <div *ngFor="let e of errors()" class="text-red-600 text-sm">{{ e.errorMessage }}</div>
         </div>
      </div>

      <div class="mt-4 m-2">
         <p-messages severity="info" [closable]="false">
            <ng-template pTemplate>
               <div class="flex flex-row gap-3 py-4 px-2">
                  <i class="pi pi-info-circle text-2xl"></i>
                  <div class="flex flex-column gap-1">
                     <span class="font-bold">{{
                        'DATA.MODULES.INSPECTORS.OFFER_PAYMENT_AGREEMENT.INFO.TITLE' | translate
                     }}</span>
                     <span class="line-height-3">
                        {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.PARTIAL_PAYMENT_PROPOSAL' | translate }}
                        <b
                           >{{ numberOfInstalments() ?? 'N' }}
                           {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.FEE' | translate }}
                        </b>
                        {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.EXPIRATION_DAYS' | translate }}
                        <b>
                           {{ expirationDays() ?? 'N' }}
                           {{
                              (expirationDays() ?? 0) === 1
                                 ? ('DATA.COMMON.TIME.DAY' | translate)
                                 : ('DATA.COMMON.TIME.DAYS' | translate)
                           }}
                        </b>
                        <span
                           [innerHTML]="'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.FROM_DAY' | translate"
                        ></span>
                        <b>
                           {{ numberOfInstalments() ?? 'N' }}
                           {{
                              (numberOfInstalments() ?? 0) === 1
                                 ? ('DATA.COMMON.TIME.MONTH' | translate)
                                 : ('DATA.COMMON.TIME.MONTHS' | translate)
                           }} </b
                        >.
                        {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.EXACT_DAY' | translate }}
                     </span>
                  </div>
               </div>
            </ng-template>
         </p-messages>
      </div>
   </div>

   <!-- Config tab -->
   <div *ngIf="activeTab() === 'config'" class="p-3 pb-4">
      <div class="flex flex-column gap-4">
         <!-- Number of instalments -->
         <div class="flex flex-column gap-2">
            <label class="font-semibold text-800">{{
               'DATA.MODULES.INSPECTORS.OFFER_PAYMENT_AGREEMENT.CONFIG.INSTALLMENTS_LABEL' | translate
            }}</label>
            <span class="text-500 text-sm">{{
               'DATA.MODULES.INSPECTORS.OFFER_PAYMENT_AGREEMENT.CONFIG.INSTALLMENTS_HELP' | translate
            }}</span>

            <p-inputNumber
               type="number"
               min="1"
               max="24"
               class="w-full rounded-lg border p-2"
               styleClass="w-full"
               [ngModel]="numberOfInstalments()"
               (ngModelChange)="onInstalmentsChange($event)"
            />
         </div>

         <p-divider></p-divider>

         <!-- Expiration -->
         <div class="flex flex-column gap-3">
            <div class="flex flex-column gap-2">
               <label class="font-semibold text-800">{{
                  'DATA.MODULES.INSPECTORS.OFFER_PAYMENT_AGREEMENT.CONFIG.EXPIRATION_LABEL' | translate
               }}</label>
               <span class="text-500 text-sm">{{
                  'DATA.MODULES.INSPECTORS.OFFER_PAYMENT_AGREEMENT.CONFIG.EXPIRATION_HELP' | translate
               }}</span>
               <p-inputNumber
                  type="number"
                  min="1"
                  max="90"
                  class="w-full rounded-lg border p-2"
                  styleClass="w-full"
                  [ngModel]="expirationDays()"
                  (ngModelChange)="onExpirationDaysChange($event)"
                  [suffix]="'DATA.MODULES.INSPECTORS.OFFER_PAYMENT_AGREEMENT.CONFIG.DAYS_SUFFIX' | translate"
               />
            </div>
         </div>

         <div *ngIf="errors().length">
            <div *ngFor="let e of errors()" class="text-red-600 text-sm">{{ e.errorMessage }}</div>
         </div>
      </div>
   </div>
</div>
